import React from 'react';
import { FormControlLabel, Checkbox as MUICheckbox } from '@material-ui/core';

const Checkbox = ({ label, ...restProps }) => {
  return <FormControlLabel control={<MUICheckbox {...restProps} />} label={label} />;
};

export default Checkbox;
